import React, { Component } from 'react';
import { style, theme } from 'constants';
import { Image, View } from 'react-native';
import { ImageProgress, CachedImage } from 'core';
const styles = style({
  s: {
    width: 50,
    height: 50,
    borderRadius: 25
  },
  l: {
    width: 120,
    height: 120,
    borderRadius: 60
  },
  avatar_progress: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    backgroundColor: theme.gray_color_alpha(0.8)
  }
});

export class Avatar extends Component {
  render() {
    let { data, is_large, size, style, uri, avatar_status, file, onUploadSuccess } = this.props;
    const upload = data && { user_id: data.is_pm?data.member_id:data.id, file_id:  data.photo };
    const photo_size = is_large ? 'l' : 's';
    size = size ? { width: size, height: size, borderRadius: parseInt(size / 2, 10) } : {};
    const is_group = data && data.type === 'GROUP';

    return (
      <View style={[styles[photo_size], { backgroundColor: '#DDDDDD', alignItems: 'center' }, style, size]}>
        {uri ? <Image style={[styles[photo_size], size]} source={{ uri: uri }} /> : null}
        {data && !data.inactive ? (
          <CachedImage size={size} is_large={is_large} upload={upload} style={[styles[photo_size], size]} is_group={is_group} />
        ) : null}
        {avatar_status && file ? (
          <ImageProgress status={avatar_status} file={file} style={[styles.avatar_progress, styles[photo_size], size]} onSuccess={onUploadSuccess} />
        ) : null}
      </View>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/core/avatar.js